/**
 * Generated bundle index. Do not edit.
 */

export * from './swiper-angular';
